import { render, staticRenderFns } from "./gl-menu-item.vue?vue&type=template&id=6243df30"
import script from "./gl-menu-item.vue?vue&type=script&lang=js"
export * from "./gl-menu-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports